<div class="crm-preferences-page">
  <mat-tab-group
    [(selectedIndex)]="matTabIndex"
    (selectedIndexChange)="updateUrl($event)"
    class="crm-preferences-page__tabs"
    animationDuration="0ms"
    disableRipple
  >
    <mat-tab>
      <ng-template mat-tab-label>
        <div class="crm-preferences-page__tab-label">
          <app-icon name="press"></app-icon>
          <span>{{ "CRM.PREFERENCES.mailTemplate" | translate }}</span>
        </div>
      </ng-template>

      <ng-container *ngTemplateOutlet="mailTemplates; context: { tabIndex: 0 }"></ng-container>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <div class="crm-preferences-page__tab-label">
          <app-icon name="signature"></app-icon>
          <span>{{ "CRM.PREFERENCES.signature" | translate }}</span>
        </div>
      </ng-template>

      <ng-container *ngTemplateOutlet="signature; context: { tabIndex: 1 }"></ng-container>
    </mat-tab>
  </mat-tab-group>
</div>

<ng-template #mailTemplates let-tabIndex="tabIndex">
  <div class="crm-preferences-page__section">
    <div class="crm-preferences-page__toolbar">
      <div class="crm-preferences-page__toolbar-copy">
        <span class="crm-preferences-page__eyebrow font-walter">
          {{ 'crm.pages.crm.preferences.crm.preferences.preferenze' | translate }}
        </span>
        <h3 class="crm-preferences-page__title">
          {{ "CRM.PREFERENCES.mailTemplate" | translate }}
        </h3>
        <p class="crm-preferences-page__description">
          {{ 'crm.pages.crm.preferences.crm.preferences.gestisciITemplateEmailDisponibiliPerIlTeam' | translate }}
        </p>
      </div>

      <div class="crm-preferences-page__toolbar-actions">
        <button
          type="button"
          class="crm-preferences-page__btn crm-preferences-page__btn--primary force-text-white"
          (click)="openRowDetail(null)"
        >
          <span>{{ 'CREA' | translate }}</span>
        </button>
      </div>
    </div>

    @if (matTabIndex === tabIndex) {
      <div class="crm-preferences-page__table-shell">
        <app-tree
          [dataSource]="messageTemplates"
          [columns]="['label', 'body', 'shared']"
          (clickRow)="openRowDetail($event)"
          [actions]="messageTemplateActions"
          [widgetOptions]="widgetOptions"
        ></app-tree>
      </div>
    }
  </div>
</ng-template>

<ng-template #createNewMessageTemplate let-data>
  <div></div>
</ng-template>

<ng-template #signature>
  <div class="crm-preferences-page__section">
    <div class="crm-preferences-page__toolbar">
      <div class="crm-preferences-page__toolbar-copy">
        <span class="crm-preferences-page__eyebrow font-walter">
          {{ 'crm.pages.crm.preferences.crm.preferences.preferenze' | translate }}
        </span>
        <h3 class="crm-preferences-page__title">
          {{ 'CRM.PREFERENCES.yourSignature' | translate }}
        </h3>
        <p class="crm-preferences-page__description">
          {{ 'crm.pages.crm.preferences.crm.preferences.visualizzaEAggiornaLaFirmaPersonaleUtilizzataNelle' | translate }}
        </p>
      </div>
    </div>

    <div class="crm-preferences-page__signature-shell">
      <div class="crm-preferences-page__signature-preview">
        @if (userSignature) {
          <div class="crm-preferences-page__signature-content" [innerHTML]="userSignature"></div>
        } @else {
          <div class="crm-preferences-page__empty-state">
            <div class="crm-preferences-page__empty-icon">
              <app-icon name="signature"></app-icon>
            </div>
            <div class="crm-preferences-page__empty-copy">
              <span class="crm-preferences-page__empty-title">
                {{ 'crm.pages.crm.preferences.crm.preferences.nessunaFirmaDisponibile' | translate }}
              </span>
              <span class="crm-preferences-page__empty-text">
                {{ 'crm.pages.crm.preferences.crm.preferences.impostaUnaFirmaPersonaleDaUsareNelleComunicazioni' | translate }}
              </span>
            </div>
          </div>
        }
      </div>

      <div class="crm-preferences-page__signature-actions">
        <button
          type="button"
          class="crm-preferences-page__btn crm-preferences-page__btn--primary force-text-white"
          (click)="openEditSignature()"
        >
          <span>{{ 'MODIFICA' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #signatureModal>
  <app-modal-container
    [title]="'CRM.PREFERENCES.MODIFICA' | translate"
    (closeButton)="closeDialog()"
  >
    <app-user-signature></app-user-signature>
  </app-modal-container>
</ng-template>
